import { useState } from "react";

export type RemoteAssetAction = "bulkDelete" | "update" | "bulkUpdateForking";

export type MutationStatus =
    | { type: "idle" }
    | { type: "pending"; action: RemoteAssetAction }
    | { type: "success"; action: RemoteAssetAction }
    | { type: "error"; action: RemoteAssetAction; message: string };

export type SetMutationStatus = (status: MutationStatus) => void;

export const useMutationStatus = (): [MutationStatus, SetMutationStatus] => {
    return useState<MutationStatus>({ type: "idle" });
};
